import { SearchNetworkSettings } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useUpdateNetworkSearchSettings } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

interface Props {
  searchSettings: SearchNetworkSettings
}

export const OfficialResourceSpaces = ({ searchSettings }: Props) => {
  const { mutate: updateNetworkSearchSettings, isLoading } =
    useUpdateNetworkSearchSettings()
  const { $t } = useI18n()

  const submit = (data: { spaces: string[] }) => {
    const { spaces } = data

    updateNetworkSearchSettings(
      {
        input: {
          officialResourcesSpaceIds: spaces,
        },
      },
      {
        onSuccess: () => {
          toast({
            title: $t({
              defaultMessage: 'Search settings updated.',
              id: 'Admin.SearchSettings.Updated',
            }),
            status: 'success',
          })
        },
        onError: () => {
          toast({
            title: $t({
              defaultMessage: 'Unable to update search settings.',
              id: 'Admin.SearchSettings.FailedToUpdate',
            }),
            status: 'error',
          })
        },
      },
    )
  }

  return (
    <Form
      defaultValues={{
        spaces: searchSettings.officialResourcesSpaceIds,
      }}
      onSubmit={submit}
    >
      {({ formState: { isDirty } }) => (
        <Card>
          <Card.Header
            title={$t({
              defaultMessage: 'Official Resource {SPACES_CC}',
              id: 'Admin.Search.OfficialResourceSpaces.Title',
            })}
            description={$t({
              defaultMessage:
                'Select the {SPACES} that contain official knowledge or verified content in your {COMMUNITY}.',
              id: 'Admin.Search.OfficialResourceSpaces.Description',
            })}
          />
          <Card.Content>
            <div className="web:col-span-12 web:md:col-span-8 flex flex-col space-y-5">
              <Form.SpaceIdPicker
                multiple
                name="spaces"
                helperText={$t({
                  defaultMessage:
                    'These {SPACES} will be grouped separately from other posts in search results and prioritized when generating answers with the Ask AI feature (if enabled).',
                  id: 'Admin.Search.OfficialResourceSpaces.SpacesPickerHelperText',
                })}
              />
            </div>
          </Card.Content>
          <Card.Actions>
            <Button
              type="submit"
              loading={isLoading}
              disabled={!isDirty || isLoading}
            >
              <T defaultMessage="Update" id="Generics.Update" />
            </Button>
          </Card.Actions>
        </Card>
      )}
    </Form>
  )
}
